import { render, staticRenderFns } from "./ContenutiBoutique.vue?vue&type=template&id=701fcded&scoped=true"
import script from "./ContenutiBoutique.vue?vue&type=script&lang=js"
export * from "./ContenutiBoutique.vue?vue&type=script&lang=js"
import style0 from "./ContenutiBoutique.vue?vue&type=style&index=0&id=701fcded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701fcded",
  null
  
)

export default component.exports